import ReactComponent from '@/components/ReactComponent';
import { faFileMedical } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { computed, makeObservable } from 'mobx';

class IconeAjustarVoto extends ReactComponent {
    constructor(props) {
        super(props);
        makeObservable(this, {
            registro: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    isComponenteHabilitado(nomeComponente) {
        return this.parametroStore.isComponenteHabilitado(nomeComponente);
    }

    ajustarVoto = async () => {
        await this.processoService.ajustarVoto(this.registro);
    };

    render() {
        if (!this.usuarioStore.isUsuarioAdmin() || this.registro.confirmadaInclusaoPauta !== true) {
            return null;
        }
        return (
            <Tooltip title={<Typography>Ajustar voto</Typography>}>
                <FontAwesomeIcon
                    icon={faFileMedical}
                    style={{ fontSize: '24px' }}
                    color="red"
                    onClick={this.ajustarVoto}
                />
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(IconeAjustarVoto));
